/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { NgModule } from "@angular/core";
import { ClipboardPrimaryDesktopMonitorService } from "./common-clipboard-desktop-monitor.service";

@NgModule({
   imports: [],
   providers: [ClipboardPrimaryDesktopMonitorService]
})
export class ChromeClipboardModule {}
